export const SESSION_CONFIRMATION_EXCLUSION_ERROR = 'SESSION_CONFIRMATION_EXCLUSION_ERROR';
export const SESSION_CONFIRMATION_EXCLUSION_LOADING = 'SESSION_CONFIRMATION_EXCLUSION_LOADING';
export const SESSION_CONFIRMATION_EXCLUSION_GET = 'SESSION_CONFIRMATION_EXCLUSION_GET';
